import { Trans, useTranslation } from 'react-i18next';

import { SALES_MODEL_COPY } from '../../../constants/prospects';
import { TRANSLATIONS_PROSPECTS } from '../../../translations/prospects';
import type { ProspectSalesModel } from '../../../types/prospects';
import CustomButton from '../../Buttons/CustomButton/CustomButton';
import { CustomModal } from '../CustomModal/CustomModal';

import './DiscardQuotesModal.scss';

interface IDiscardQuotesModalProps {
  open: boolean;
  savedQuotesCount: number;
  currentSalesModel: ProspectSalesModel;
  nextSalesModel: ProspectSalesModel;
  onKeep: () => void;
  onConfirm: () => void;
}

const DiscardQuotesModal = ({
  open,
  savedQuotesCount,
  currentSalesModel,
  nextSalesModel,
  onKeep,
  onConfirm
}: IDiscardQuotesModalProps) => {
  const { t } = useTranslation();
  const { title, body, keep, confirm } = TRANSLATIONS_PROSPECTS.profile.discardQuotes;

  return (
    <CustomModal open={open} title={t(title)} onClose={onKeep} size="m">
      <p className="discard-quotes-modal__body">
        <Trans
          i18nKey={body}
          count={savedQuotesCount}
          values={{
            count: savedQuotesCount,
            currentModel: t(SALES_MODEL_COPY[currentSalesModel].title),
            nextModel: t(SALES_MODEL_COPY[nextSalesModel].title)
          }}
          components={{ b: <b /> }}
        />
      </p>

      <div className="discard-quotes-modal__footer">
        <CustomButton variant="default" size="m" onClick={onKeep}>
          {t(keep)}
        </CustomButton>
        <CustomButton variant="lost" size="m" onClick={onConfirm}>
          {t(confirm)}
        </CustomButton>
      </div>
    </CustomModal>
  );
};

export default DiscardQuotesModal;
